import { Paper, Typography } from "@mui/material";

export const StraightenerRunsSummary = ({ count }: { count: number }) => (
	<Paper elevation={1} sx={{ px: 2, py: 0.75 }}>
		<Typography variant="body2">
			<strong>Total:</strong> {count} runs
		</Typography>
	</Paper>
);
